import { useLayoutEffect } from "react";
import { useEffectEvent } from "./useEffectEvent.js";

/**
 * Helper hook to attach event handlers to DOM elements.
 * Handler does not need to have a stable identity.
 */
export function useEventListener<T extends keyof WindowEventMap>(
  eventName: T,
  handler: (event: WindowEventMap[T]) => void,
  element: EventTarget,
  capture = false
) {
  const effectEvent = useEffectEvent(handler);

  useLayoutEffect(() => {
    element.addEventListener(eventName, effectEvent, capture);
    return () => {
      element.removeEventListener(eventName, effectEvent, capture);
    };
  }, [element, eventName, capture]);
}
